import * as GCV from '@google-cloud/vision'
import { json } from '@remix-run/node'
import { useSubmit } from '@remix-run/react'

const client = new GCV.v1.ImageAnnotatorClient()

/**
 * TODO(developer): Uncomment the following lines before running the sample.
 */
// Bucket where the file resides
const bucketName = 'bookmarks-dev-uploads'
// Path to PDF file within bucket
const fileName = 'pdf-testing/2025-03-06 16-33.pdf'
// The folder to store the results
const outputPrefix = 'ocr-outputs'

const gcsSourceUri = `gs://${bucketName}/${fileName}`
const gcsDestinationUri = `gs://${bucketName}/${outputPrefix}/`

const inputConfig = {
	// Supported mime_types are: 'application/pdf' and 'image/tiff'
	mimeType: 'application/pdf',
	gcsSource: {
		uri: gcsSourceUri,
	},
}
const outputConfig = {
	gcsDestination: {
		uri: gcsDestinationUri,
	},
}
const features = [{ type: 'DOCUMENT_TEXT_DETECTION' }]
const request = {
	requests: [
		{
			inputConfig: inputConfig,
			features: features,
			outputConfig: outputConfig,
		},
	],
}

async function doPdfOcr() {
	const [operation] = await client.asyncBatchAnnotateFiles(request)
	const [filesResponse] = await operation.promise()
	const destinationUri =
		filesResponse.responses[0].outputConfig.gcsDestination.uri
	console.log('Json saved to: ' + destinationUri)
}

export async function action() {
	await doPdfOcr()
	return json({ result: 'success' })
}

export default function PdfOcrTestingRoute() {
	const submit = useSubmit()
	return (
		<div>
			<button
				onClick={() => {
					submit(null, { method: 'post' })
				}}
			>
				Do test
			</button>
		</div>
	)
}
